module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 19
// module chunks = 0